import pic6 from "../Images/6.jpg";

import pic3 from "../Images/3.jpg";

const CardData2 = [
  {
    imgsrc: pic3,
    title: "Web development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic3,
    title: "App development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic3,
    title: "Software development",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic6,
    title: "Content Writing",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic6,
    title: "Fashion design",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
  {
    imgsrc: pic6,
    title: "Entrepreneur",
    desc: " ipsum dolor sit amet consectetur adipisicing elit. Illum, ratione!",
  },
];
export default CardData2;
